"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Login_1 = __importDefault(require("../components/Login/View/Login"));
var user_hook_1 = require("../context/UserContext/user.hook");
var userContext_1 = require("../context/UserContext/userContext");
var AdminRouter_1 = __importDefault(require("../router/AdminRouter"));
var roles_1 = require("../router/roles");
var routes_1 = require("../router/routes");
var history_1 = __importDefault(require("./history"));
var UmvaRouter = function () {
    var _a, _b;
    var userCntx = (0, user_hook_1.useUser)();
    var filtredRole = (_b = (_a = userCntx === null || userCntx === void 0 ? void 0 : userCntx.user) === null || _a === void 0 ? void 0 : _a.roles) === null || _b === void 0 ? void 0 : _b.filter(function (l) {
        return roles_1.roles.admins.includes(l.name);
    });
    return (react_1.default.createElement(userContext_1.UserContext.Provider, { value: userCntx },
        react_1.default.createElement(react_router_dom_1.Router, { history: history_1.default },
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { component: Login_1.default, exact: true, path: routes_1.NonAuthRoutes.login }),
                userCntx.user && filtredRole && (filtredRole === null || filtredRole === void 0 ? void 0 : filtredRole.length) > 0 && (react_1.default.createElement(AdminRouter_1.default, null))))));
};
exports.default = UmvaRouter;
